module.exports = __webpack_public_path__ + "static/media/fale-conosco-telefone.5723deec.png";